import { i18n as _i18n } from "@lingui/core";
import { formNames } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { GenericFieldBoxSelect } from './GenericFieldBoxSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitFuelType(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.fuelType'
    }),
    ...props
  } = _ref;
  const {
    carTypesSplitModule: {
      getFuelTypes
    }
  } = useModulesStore();
  return /*#__PURE__*/_jsx(GenericFieldBoxSelect, {
    label: label,
    name: formNames.fuelType,
    dataQueryFn: getFuelTypes,
    ...props
  });
}